import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const OutOfStockStatus = styled.div`
    color: ${getPurpurColor('red600')};
    ${sideSpacingOfHeaderFooter};
    margin-top: ${getPurpurSpacing('300')};
`;
